
// Redux

/***** Recibimos acción. Vamos a Post para hacer dispatch a esta acción *****/

import { FETCH_ALL_POSTS, FETCH_MY_POSTS, FETCH_BY_PAGE, FETCH_POST, CREATE, UPDATE, DELETE, FETCH_BY_SEARCH, START_LOADING, END_LOADING, UPDATE_RETURN_ONE } from "../constants/actionTypes"

export default (state = { isLoading: true, posts: [] }, action) => {
    switch (action.type) {
        case START_LOADING:
            return { ...state, isLoading: true }
        case END_LOADING:
            return { ...state, isLoading: false }
        case FETCH_BY_PAGE:
            return {
                ...state,
                posts: action.payload.posts,
                currentPage: action.payload.currentPage,
                numberOfPages: action.payload.numberOfPages,
                myPosts: action.payload.myPosts,
                popularPosts: action.payload.popularPosts,
            };
        case FETCH_ALL_POSTS:
            return { ...state, post: action.payload.post }
        case FETCH_MY_POSTS:
            return { ...state, posts: action.payload.posts }
        case FETCH_BY_SEARCH:
            return {
                ...state, posts: action.payload.posts,
                currentPage: action.payload.currentPage,
                numberOfPages: action.payload.numberOfPages,
            }
        case FETCH_POST:
            return { ...state, post: action.payload.post }
        case CREATE:
            return { ...state, posts: [...state.posts, action.payload] }
        case UPDATE:
            return {
                ...state,
                posts: state.posts.map((post) => post._id === action.payload.updatedPost._id ? action.payload.updatedPost : post),
               
                myPosts: action.payload.myPosts,
                popularPosts: action.payload.popularPosts
            }
        case UPDATE_RETURN_ONE:
            return {
                ...state,
                myPosts: state.myPosts.map((post) => post._id === action.payload.updatedPost._id ? action.payload.updatedPost : post),
            }
        case DELETE:
            return { ...state, posts: state.posts.filter((post) => post._id !== action.payload) }
        default:
            return state
    }
}